/**
 * Created by Huy Nguyen on 11/02/17.
 */

export default class IceBreaker {
  itemId: number;
  itemName: string;
  constructor() {
    this.itemId = 0;
    this.itemName = '';
  }

  static mappingObject(_iceBreaker: any): IceBreaker {
    const iceBreaker = Object.assign(new IceBreaker(), _iceBreaker);
    iceBreaker.itemId = _iceBreaker.ItemID;
    iceBreaker.itemName = _iceBreaker.ItemName;
    return iceBreaker;
  }

  static mappingObjects(_iceBreakers: any[]): IceBreaker[] {
    const iceBreakers: IceBreaker[] = [];
    _iceBreakers.forEach(_iceBreaker => {
      const iceBreaker = IceBreaker.mappingObject(_iceBreaker);
      iceBreakers.push(iceBreaker);
    });
    return iceBreakers;
  }
}
